import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default function TrainerInfoItem({ label, children }) {
  return (
    <div className="flex items-center w-full space-x-2">
      <div className="text-base font-medium">{label}</div>
      <div className="flex-1 border-b-2 border-dashed border-gray-100" />
      <div className="text-base">{children}</div>
    </div>
  );
}

TrainerInfoItem.defaultProps = defaultProps;
TrainerInfoItem.propTypes = propTypes;
